import Component from "../abstracts/Component";

export default class ListingLayoutComponent extends Component {
  get SELECTORS() {
    return {
      main: '[data-listing-layout]'
    }
  }

  get CLASSES() {
    return {
      active: 'is-active'
    }
  }

  constructor() {
    super();
  }

  bindEvents() {

    this.$on('click.listingLayout', ({event}) => {
      if (event.target.classList.contains(this.CLASSES.active)) return;

      const target = event.target;
      target.parentElement.childNodes.forEach(child => child.classList.remove(this.CLASSES.active));
      target.parentElement.dataset.listingLayout = target.dataset.listingLayoutType;
      target.classList.add(this.CLASSES.active);

      this.$emit(this.$customEvents.PAGE_LAYOUT_EVENTS.changed, {layout: target.dataset.listingLayoutType});
    }, this.SELECTORS.main);
  }

  render() {
    if (document.querySelector(this.SELECTORS.main)) this.bindEvents();
  }
}
